"use strict";
/**
 * Home's words (Anthony's Home spec, 2026-10-13; reports 133 and 136), shared by both
 * apps' Home under rule 17. Verbatim from web's Home components on develop (d4c874f9);
 * web moves onto these keys in a follow-up and deletes its frontend/src/lib/homeCopy.ts.
 *
 * Helpers take preformatted dates and currency, so each app keeps its own formatting.
 * "Payday" and "Paychecks before payday" are constants on purpose: which paycheck
 * counts as payday with two in a period is open (report 139), and a rename must be
 * one line.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOME_TRY_AGAIN_COPY = exports.HOME_LOAD_ERROR_COPY = exports.HOME_RECONNECT_COPY = exports.HOME_MAY_BE_OUT_OF_DATE_COPY = exports.HOME_PENDING_COPY = exports.HOME_NO_PURCHASES_COPY = exports.HOME_ALL_ACTIVITY_COPY = exports.HOME_LATEST_TITLE_COPY = exports.HOME_NO_PAYOFF_DATE_COPY = exports.HOME_OWED_COPY = exports.HOME_DEBT_COPY = exports.HOME_BEHIND_COPY = exports.HOME_ON_TRACK_COPY = exports.HOME_SET_A_GOAL_COPY = exports.HOME_NO_GOALS_OR_DEBTS_COPY = exports.HOME_GOALS_DEBT_TITLE_COPY = exports.HOME_TILE_PERIOD_ENDS_COPY = exports.HOME_TILE_PROJECTED_COPY = exports.HOME_TILE_PAYCHECKS_COPY = exports.HOME_TILE_BILLS_DUE_COPY = exports.HOME_TILE_BALANCE_TODAY_COPY = exports.HOME_BALANCE_COPY = exports.HOME_PERIOD_ENDS_COPY = exports.HOME_PAYDAY_COPY = exports.HOME_TODAY_COPY = exports.HOME_OPEN_CALENDAR_COPY = exports.HOME_LEGEND_PROJECTED_COPY = exports.HOME_LEGEND_PAYCHECK_COPY = exports.HOME_LEGEND_BILLS_COPY = exports.HOME_TIMELINE_SUBTITLE_COPY = exports.HOME_TIMELINE_TITLE_COPY = exports.HOME_FOUND_DEBTS_HINT_COPY = exports.HOME_REVIEW_ACTION_COPY = exports.HOME_SORT_ACTION_COPY = exports.HOME_WHICH_CATEGORY_COPY = exports.HOME_NEEDS_ATTENTION_TITLE_COPY = exports.HOME_CHECKLIST_DISMISS_COPY = exports.HOME_CHECKLIST_GOAL_COPY = exports.HOME_CHECKLIST_SORT_COPY = exports.HOME_CHECKLIST_TITLE_COPY = exports.HOME_SINCE_LAST_VISIT_LABEL_COPY = exports.HOME_NEXT_30_DAYS_COPY = exports.HOME_REFRESH_LABEL_COPY = exports.HOME_UPDATING_COPY = void 0;
exports.homePeriodLabel = homePeriodLabel;
exports.sinceLastVisitLine = sinceLastVisitLine;
exports.foundDebtsCopy = foundDebtsCopy;
exports.seeAllToSortCopy = seeAllToSortCopy;
exports.paidOffByCopy = paidOffByCopy;
exports.moreInPlanCopy = moreInPlanCopy;
exports.setAsideEachPaycheckCopy = setAsideEachPaycheckCopy;
exports.neededPaceCopy = neededPaceCopy;
exports.targetDateCopy = targetDateCopy;
exports.ofTargetCopy = ofTargetCopy;
exports.numbersAreFromCopy = numbersAreFromCopy;
// ── Header ──────────────────────────────────────────────────────────────────────────
exports.HOME_UPDATING_COPY = "Updating…";
exports.HOME_REFRESH_LABEL_COPY = "Refresh bank data";
/** With no paycheck detected there is no pay period: a forward look instead. */
exports.HOME_NEXT_30_DAYS_COPY = "Next 30 days";
function homePeriodLabel(start, end) {
    return `Pay period ${start} – ${end}`;
}
// ── Since your last visit (HP-21) and the first-week checklist (RD-32) ──────────────
exports.HOME_SINCE_LAST_VISIT_LABEL_COPY = "Since your last visit";
exports.HOME_CHECKLIST_TITLE_COPY = "Your first week";
exports.HOME_CHECKLIST_SORT_COPY = "Sort the purchases we couldn't place";
exports.HOME_CHECKLIST_GOAL_COPY = "Add a goal (optional)";
exports.HOME_CHECKLIST_DISMISS_COPY = "Dismiss";
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
/** "6 new purchases · $142 spent · Mobile bill paid", the spec's own example's shape.
 *  `formatWholeDollars` formats the rounded amount spent (each app's own formatter). */
function sinceLastVisitLine(visit, formatWholeDollars) {
    const parts = [];
    const bills = visit.bills_paid ?? visit.billsPaid ?? [];
    if (visit.purchases > 0) {
        parts.push(plural(visit.purchases, "new purchase", "new purchases"));
        parts.push(`${formatWholeDollars(Math.round(Number(visit.spent)))} spent`);
    }
    // Up to two bills by name, as the example; more than that is a count, so the line
    // stays one line.
    if (bills.length > 2)
        parts.push(`${bills.length} bills paid`);
    else
        for (const bill of bills)
            parts.push(`${bill} paid`);
    return parts.join(" · ");
}
// ── Needs your attention (HP-05 / 06 / 08) ──────────────────────────────────────────
exports.HOME_NEEDS_ATTENTION_TITLE_COPY = "Needs your attention";
exports.HOME_WHICH_CATEGORY_COPY = "Which category is this?";
exports.HOME_SORT_ACTION_COPY = "Sort";
exports.HOME_REVIEW_ACTION_COPY = "Review";
exports.HOME_FOUND_DEBTS_HINT_COPY = "Add them to your plan or dismiss them.";
function foundDebtsCopy(count) {
    return `We found ${count} ${count === 1 ? "debt" : "debts"}`;
}
function seeAllToSortCopy(count) {
    return `See all ${count} to sort`;
}
// ── Your transaction timeline (HP-12 / 13 / 14) ─────────────────────────────────────
exports.HOME_TIMELINE_TITLE_COPY = "Your transaction timeline";
exports.HOME_TIMELINE_SUBTITLE_COPY = "What's coming in and going out until payday, and your balance after each one.";
exports.HOME_LEGEND_BILLS_COPY = "Bills";
exports.HOME_LEGEND_PAYCHECK_COPY = "Paycheck";
exports.HOME_LEGEND_PROJECTED_COPY = "Projected balance";
exports.HOME_OPEN_CALENDAR_COPY = "Open calendar";
exports.HOME_TODAY_COPY = "Today";
exports.HOME_PAYDAY_COPY = "Payday";
exports.HOME_PERIOD_ENDS_COPY = "Period ends";
exports.HOME_BALANCE_COPY = "Balance";
exports.HOME_TILE_BALANCE_TODAY_COPY = "Balance today";
exports.HOME_TILE_BILLS_DUE_COPY = "Bills due before payday";
exports.HOME_TILE_PAYCHECKS_COPY = "Paychecks before payday";
/** Forecast's own words for the period-end figure, exactly (its timeline's last marker). */
exports.HOME_TILE_PROJECTED_COPY = "Projected Balance";
exports.HOME_TILE_PERIOD_ENDS_COPY = "Period Ends";
// ── Goals & debt (HP-17) ─────────────────────────────────────────────────────────────
exports.HOME_GOALS_DEBT_TITLE_COPY = "Goals & debt";
exports.HOME_NO_GOALS_OR_DEBTS_COPY = "No goals or debts yet.";
exports.HOME_SET_A_GOAL_COPY = "Set a goal in Plan";
exports.HOME_ON_TRACK_COPY = "On track";
exports.HOME_BEHIND_COPY = "Behind";
exports.HOME_DEBT_COPY = "Debt";
exports.HOME_OWED_COPY = "owed";
exports.HOME_NO_PAYOFF_DATE_COPY = "No payoff date yet";
function paidOffByCopy(date) {
    return `Paid off by ${date} on your plan`;
}
function moreInPlanCopy(count) {
    return `${count} more in Plan`;
}
function setAsideEachPaycheckCopy(amount) {
    return `${amount} set aside each paycheck`;
}
function neededPaceCopy(amount, date) {
    return `Needs ${amount} a month to reach it by ${date}`;
}
function targetDateCopy(date) {
    return `Target ${date}`;
}
function ofTargetCopy(amount) {
    return `of ${amount}`;
}
// ── Latest (HP-18 / 19) ──────────────────────────────────────────────────────────────
exports.HOME_LATEST_TITLE_COPY = "Latest";
exports.HOME_ALL_ACTIVITY_COPY = "All activity";
exports.HOME_NO_PURCHASES_COPY = "No purchases yet this period.";
exports.HOME_PENDING_COPY = "pending";
// ── Bank unreachable (HP-24) and errors ─────────────────────────────────────────────
function numbersAreFromCopy(when) {
    return `Numbers are from ${when}.`;
}
exports.HOME_MAY_BE_OUT_OF_DATE_COPY = "These numbers may be out of date.";
exports.HOME_RECONNECT_COPY = "Reconnect";
exports.HOME_LOAD_ERROR_COPY = "Couldn't load Home. Nothing has changed.";
exports.HOME_TRY_AGAIN_COPY = "Try again";
//# sourceMappingURL=homeCopy.js.map